import React from 'react'
import styled from 'styled-components'
import utmLinkGenerator from '../utils/UTMLinkGenerator'
import { SIZES } from '../../constants'

const Link = styled.a`
  display: block;
  border: 0;
  margin: 0 0 20px 0;
`

const Image = styled.img`
  height: auto;
  width: 100%;
  
  @media (min-width: ${SIZES.BREAKPOINT_XS}px) {
    width: calc(100% + 2px);
  }
`

const TARGET_LINK = 'https://zpravy.aktualne.cz/zahranici/rusky-utok-na-ukrajinu-2022-vse-o-tematu/r~df9a852493f511ec8a24ac1f6b220ee8/'

const BbxInfoWidget = props => {
  const {
    widget: {
      utmMeta
    },
    activeDynamicLayout
  } = props

  const imageSrc = `${STATICS_PATH}images/widgets/bbxinfo/ukrajina_widget_${activeDynamicLayout}.png`

  const href = utmLinkGenerator.createLink(TARGET_LINK, utmMeta)

  return <Link href={href}><Image src={imageSrc} alt='Ukrajina - anexe'/></Link>
}

export default BbxInfoWidget
